import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  DURATION,
  NOTICE_PERIOD,
  RENEWAL_TERM,
  PAYMENT_TERM,
} from '../../constants/agreement.constant';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { HttpService } from '../../services/http.service';
import { saveAs } from 'file-saver';
import * as JSZip from 'jszip';
import { TableService } from '../../services/tableService/table.service';

@Component({
  selector: 'app-agreement-information',
  templateUrl: './agreement-information.component.html',
  styleUrls: ['./agreement-information.component.scss'],
})
export class AgreementInformationComponent implements AfterViewInit, OnChanges {
  public agreementForm: FormGroup;

  public durationList = DURATION;
  public noticePeriodList = NOTICE_PERIOD;
  public renewalList = RENEWAL_TERM;
  public paymentList = PAYMENT_TERM;
  public gsdbListArr: any;
  public contactNAmeArr: any;
  public contactListArr: any;
  public commodityList: any;
  public statusList: any;
  public currencyList: any;
  public categoryList: any;
  public gisNumberList: any;
  public gisClassList: any;
  public buyerMail: any;
  private removedFiles: any = [];

  public maxEnterCount = 10;
  public desRemainingChars: number = 1024;
  public isActiveDescription : boolean = false;
  public revisionRemainingChars: number = 250;
  public isActiveRevision: boolean = false;
  public specRemainingChars: number = 350;
  public isActiveSpec: boolean = false;
  
  userData: any;
  public operation: any;
  dataSource: any;
  files: any = [];

  autoFlag: boolean = false;
  selectedContact: boolean = false;
  minDate: any;
  minEffectiveDate: any;
  dbFiles: any = [];

  @Input() copyActivity: boolean = false;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    public appService: AppService,
    public dialog: MatDialog,
    private httpService: HttpService,
    public tableService: TableService
  ) {
    this.agreementForm = new FormGroup({
      rateNumber: new FormControl(null, Validators.required),
      effectiveDate: new FormControl('', Validators.required),
      expiryDate: new FormControl('', Validators.required),
      revisionNum: new FormControl(1, Validators.required),
      supersedes: new FormControl(''),
      initalDate: new FormControl('', Validators.required),

      gsdb: new FormControl('', Validators.required),
      carrierName: new FormControl('', Validators.required),
      contractName: new FormControl('', Validators.required),
      marketTest: new FormControl(''),

      street: new FormControl(''),
      city: new FormControl(''),
      country: new FormControl('', Validators.required),
      taxCode: new FormControl(''),
      zipCode: new FormControl(''),
      email: new FormControl('', Validators.required),
      phone: new FormControl(null),
      description: new FormControl('', Validators.required),

      buyermail: new FormControl('', Validators.required), //condition
      buyerName: new FormControl('', Validators.required),
      buyerCode: new FormControl('', Validators.required),
      buyerLocation: new FormControl(''),
      buyerPhone: new FormControl(''),

      revision: new FormControl(''),
      specification: new FormControl(''),
      guarantees: new FormControl(''),

      autoExtent: new FormControl('', Validators.required),
      autoComment: new FormControl(''),
      noticePeriod: new FormControl(null), //condition
      renewal: new FormControl(null), //condition

      duration: new FormControl(3, Validators.required),
      payment: new FormControl(60, Validators.required),
      commodity: new FormControl(4, Validators.required),
      currency: new FormControl(3, Validators.required),

      oldExpiryDate: new FormControl(),
      gisclassfication: new FormControl('', Validators.required),
      retentionPeriod: new FormControl(12, Validators.required),
      retentionDays: new FormControl(''),
      gisNumber: new FormControl('', Validators.required),

      modifiedBy: new FormControl(''),
      modifiedDate: new FormControl(''),
      createdDate: new FormControl('', Validators.required),
      createdBy: new FormControl(''),
    });
    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    this.dataSource = history.state.data;
    this.operation = history.state.operation;
    this.appService.rateBackUpData = [];

    if (this.operation != 'add') {
      if (this.userData.RoleID != 4) {
        this.operation = 'view';
      } else {
        sessionStorage.setItem('raID', this.dataSource.RateAgreementStatusID);
        if (this.dataSource.RateAgreementStatusID !== 39) {
          this.operation = 'view';
        }
      }
    }
    if (this.operation === 'add') {
      this.appService.raIsLoading = false;
    }
    this.appService.copyActivity = false;

    this.getCategoryType();
    this.getCOntactList();
    this.getGSDBFromCarrier();
    this.toUpdateOnField();
    this.getCountryList();
  }

  ngAfterViewInit(): void {
    this.getAttachmentFile();
    setTimeout(() => {
      Object.keys(this.agreementForm.controls).forEach((controlName) => {
        this.agreementForm
          .get(controlName)!
          .valueChanges.subscribe((value: any) => {
            this.appService.onRAvalueChanged = true;
          });
      });
    }, 2000);
  }
  getCountryList() {
    this.appService.isLoading = true;
    this.httpService.getCountryList().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        // this.countryListArr = res
        this.appService.countryListArr = res;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['copyActivity']?.currentValue) {
      this.copyActivity = changes['copyActivity']?.currentValue;
      this.onCopyActivity();
    }
  }

  onRateNumber(e: any) {
    if (e.value.length > 6) {
      this.httpService.openSnackBar('Please Enter Value with 6 Charaters.!');
      return;
    } else if (e.value.includes(' ')) {
      this.httpService.openSnackBar(
        'Please Enter Value with 6 Charaters without Empty Space.!'
      );
    }
  }

  onCopyActivity() {
    this.copyActivity = true;
    this.dataSource.RateAgreementID = null;
    this.appService.copyActivity = true;
    this.operation = 'edit';
    let ver =
      this.dataSource.RevisionNumber >= 10
        ? this.dataSource.RevisionNumber
        : '0' + this.dataSource.RevisionNumber;
    this.dataSource.SupersedesRANo =
      this.dataSource.RateAgreementNumber + 'v' + ver;
    this.dataSource.RevisionNumber = this.dataSource.RevisionNumber + 1;
    // this.getContact(this.dataSource.CarrierID);
    // from herev-- src 10 ---

    this.dataSource.CarrierID = this.gsdbListArr.find(
      (i: any) => i.ContractGSDB === this.dataSource.GSDB
    )?.CarrierID;
    this.gsdbListArr = [...this.gsdbListArr];
    this.agreementForm.get('gsdb')?.setValue(this.dataSource.CarrierID);

    // ---- till src 10 ----
    this.appService.gsdbToTableEmit.emit(this.dataSource.CarrierID);
    this.contactNAmeArr = this.contactListArr.filter(
      (item: any) =>
        item.Status !== 'Terminated' &&
        item.CarrierID === this.dataSource.CarrierID
    ); //(+item.ContactTypeID === 19) &&
    this.contactNAmeArr.sort((a: any, b: any) =>
      a.LastName.toLowerCase() > b.LastName.toLowerCase() ? 1 : -1
    );
    let findContact = this.contactNAmeArr.find(
      (i: any) => i.Email === this.dataSource.Email
    );
    this.onOptionChange({ value: '' + this.dataSource.CarrierID }, 'gsdb');
    this.appService.isLoading = false;

    this.buyerMail = this.contactListArr.filter(
      (item: any) =>
        item.ContactTypeID === 20 &&
        item.Status !== 'Terminated' &&
        item.Email === this.dataSource.BuyerEmail
    );
    this.agreementForm.get('buyermail')?.setValue(this.buyerMail[0]?.ContactID);
    this.onSelectClick('buyerEmail');
    // this.agreementForm.get('contractName')?.setValue(findContact.ContactID)

    // this.appService.gsdbToTableEmit.emit(id)
    // if(this.contactNAmeArr.length === 1){
    //   let selected = this.contactNAmeArr[0];
    this.agreementForm.patchValue({
      contractName: findContact ? findContact?.ContactID : '',
      email: findContact ? findContact?.Email : '',
      phone: findContact ? findContact?.PhoneNumber : '',
    });
    // }

    this.agreementForm.patchValue({
      revisionNum: this.dataSource.RevisionNumber,
      supersedes: this.dataSource.SupersedesRANo,
      modifiedDate: '',
      modifiedBy: '',
      // initalDate: this.appService.excelDateFormate(this.agreementForm.get('initalDate')?.value),
      // effectiveDate:this.isDateGreaterThanCurrentDate(this.agreementForm.get('effectiveDate')?.value)?this.agreementForm.get('effectiveDate')?.value:this.appService.getDateWithNewValue(1,0,0),
      // expiryDate:this.appService.excelDateFormate(this.agreementForm.get('expiryDate')?.value)
    });

    this.agreementForm.enable();
  }

  onKeyDown(event: KeyboardEvent, condition = false) {
    if (condition) return;
    event.preventDefault();
  }

handleTextareaKeydown(event: KeyboardEvent): void {
  const textarea = event.target as HTMLTextAreaElement;
  const value = textarea.value;
  if (event.key === 'Enter') {
    const enterCount = (value.match(/\n/g) || []).length;
    if (enterCount >= this.maxEnterCount) {
      this.httpService.openSnackBar("Line limit reached (10 lines maximum)");
      event.preventDefault();
    }
  }
}

updateSpecRemainingChars(event: any) {
  this.isActiveSpec = true; 
  const inputValue = event.target.value;
  const inputLength = inputValue.length;
  this.specRemainingChars = 350 - inputLength;

  setTimeout(() => {
    this.isActiveSpec = false;
  }, 5000);

  if (inputLength < this.maxEnterCount) return;

  this.validateTextArea(inputValue);
}

updateRevisionRemainingChars(event: any) {
  this.isActiveRevision = true;
  const inputValue = event.target.value;
  const inputLength = inputValue.length;
  this.revisionRemainingChars = 250 - inputLength;

  setTimeout(() => {
    this.isActiveRevision = false;
  }, 5000);

  if (inputLength < this.maxEnterCount) return;

  this.validateTextArea(inputValue);
}


updateDesRemainingChars(event: any) {
  
  this.isActiveDescription = true;
  const inputValue = event.target.value;
  const inputLength = inputValue.length;
  this.desRemainingChars = 1024 - inputLength;

  setTimeout(() => {
    this.isActiveDescription = false;
  }, 5000);

  if (inputLength < this.maxEnterCount) return;

  this.validateTextArea(inputValue);
}


private hasTooManyEmptyLines(lines: string[]): boolean {
  if (lines.length <= 1) return false;
  
  const emptyLines = lines.filter(line => line.trim() === '');
  const emptyLinePercentage = (emptyLines.length / lines.length) * 100;
  return emptyLinePercentage > 50;
}

private hasRepeatedLines(lines: string[]): boolean {
  if (lines.length <= 1) return false;
  
  const nonEmptyLines = lines.filter(line => line.trim() !== '');
  if (nonEmptyLines.length === 0) return false;
  
  return this.checkLineRepetitionFrequency(nonEmptyLines);
}

private checkLineRepetitionFrequency(nonEmptyLines: string[]): boolean {
  const lineFrequency: { [key: string]: number } = {};
  
  nonEmptyLines.forEach(line => {
    const trimmedLine = line.trim();
    if (trimmedLine.length > 1) {
      lineFrequency[trimmedLine] = (lineFrequency[trimmedLine] || 0) + 1;
    }
  });
  
  for (const line in lineFrequency) {
    const percentage = (lineFrequency[line] / nonEmptyLines.length) * 100;
    if (percentage > 50 && nonEmptyLines.length > 2) {
      return true;
    }
  }
  
  return false;
}


private validateTextArea(inputValue: string): void {
  const lines = inputValue.split('\n');
  
  if (this.hasTooManyEmptyLines(lines)) {
    this.httpService.openSnackBar("Too many empty lines detected. Please reduce blank lines");
    return;
  }
  
  if (this.hasRepeatedLines(lines)) {
    this.httpService.openSnackBar("Same content appears on multiple lines");
    return;
  }
}

  downloadFile(file: File) {
    const blob = new Blob([file], { type: file.type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.name;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  onExportFile(type: string) {
    // this.appService.fileExportEmit.emit(type);

    if (type === 'PDF') {
      //   this.appService.fileExportEmit.emit(type);
    }
    // else{

    // }
  }

  getAttachmentFile() {
    if (this.operation === 'add') {
      return;
    }
    // return;
    // this.appService.isLoading = true;
    this.httpService
      .getFileFromBlob('attachment', this.dataSource?.RateAgreementID)
      .subscribe((blob: Blob) => {
        // const zipFilename = 'files.zip';
        // saveAs(blob, zipFilename); // download as zip file
        if (blob.type === 'text/html') {
          return;
        }

        const zipReader = new FileReader();
        zipReader.onload = () => {
          const zipData = zipReader.result as ArrayBuffer;
          this.extractFilesFromZip(zipData);
        };
        zipReader.readAsArrayBuffer(blob);
      });
  }

  onDateChange(e: any, name: string) {
    if (e.value) {
      if (name === 'effectiveDate') {
        this.minDate = e.value;
      } else if (name === 'expiryDate') {
        this.agreementForm.get('expiryDate')?.setValue(e.value);
        this.agreementForm
          .get('retentionDays')
          ?.setValue(
            this.appService.getDateWithNewValue(
              this.calculateDateDiffrence(),
              0,
              Number(this.agreementForm.get('retentionPeriod')?.value)
            )
          );
      }
      this.agreementForm.get(name)?.setValue(e.value);
    }
    // this.agreementForm.get(`${name}`)!.patchValue(this.appService.formatDate(evt.value));
  }

  private extractFilesFromZip(zipData: ArrayBuffer): void {
    const zip = new JSZip();

    zip.loadAsync(zipData).then((zip: any) => {
      zip.forEach((relativePath: any, zipEntry: any) => {
        zipEntry.async('blob').then((fileData: any) => {
          const inputElement = this.fileInput.nativeElement;
          inputElement.type = 'file';
          this.files = [...this.files, new File([fileData], zipEntry.name)];
          this.dbFiles = this.files.map((i: any) => i.name);
        });
      });
    });
  }

  saveTheFiles(data: any, filename: any) {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event.target) {
        const fileContent = event.target.result;
        const blob = new Blob([fileContent as BlobPart], {
          type: 'application/octet-stream',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      }
    };
    reader.readAsArrayBuffer(data);
  }

  removeFile(i: any) {
    this.appService.onRAvalueChanged = true;
    this.removedFiles.push(this.files[i].name);
    // this.httpService.getAttachFileDeleted(this.dataSource?.RateAgreementID,this.files[i].name)
    // .subscribe((res:any) =>{
    this.files.splice(i, 1);
    // })
  }

  getCategoryType() {
    this.appService.isLoading = true;
    this.httpService.getListOfData('RateAgreement').subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.categoryList = res;
        this.currencyList = res.filter(
          (item: any) => item.Category === 'Currency'
        );

        this.commodityList = res.filter(
          (item: any) => item.Category === 'Commodity'
        );
        this.statusList = res.filter(
          (item: any) => item.Category === 'RateAgreementStatus'
        );
        this.gisNumberList = res.filter(
          (item: any) => item.Category === 'GISNumber'
        );
        this.gisClassList = res.filter(
          (item: any) => item.Category === 'GISClassification'
        );
        this.agreementForm.patchValue({
          gisclassfication: this.gisClassList[0].LookUpName,
          gisNumber: this.gisNumberList[0].LookUpName,
          // currency: this.currencyList[0].LookUpID,
          currency: this.dataSource
            ? this.dataSource.CurrencyID
            : this.currencyList[0].LookUpID,
        });
      }
    });
  }

  getCOntactList() {
    this.appService.isLoading = true;
    this.httpService.getContactDetails().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.contactNAmeArr = res;
        this.contactListArr = res;
        this.buyerMail = res.filter((item: any) => item.ContactTypeID === 20);
        // this.buyerMail = res;
      }
    });
  }

  getGSDBFromCarrier() {
    this.appService.isLoading = true;
    this.httpService.getCarrierDetails().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.gsdbListArr = res;
        this.gsdbListArr.sort((a: any, b: any) =>
          a.ContractGSDB.toLowerCase() > b.ContractGSDB.toLowerCase() ? 1 : -1
        );
      }
    });
  }

  getContact(id: number) {
    this.appService.isLoading = true;
    this.contactNAmeArr = this.contactListArr.filter(
      (item: any) => item.Status !== 'Terminated' && item.CarrierID === +id
    ); //(+item.ContactTypeID === 19) &&
    this.contactNAmeArr.sort((a: any, b: any) =>
      a.LastName.toLowerCase() > b.LastName.toLowerCase() ? 1 : -1
    );
    this.appService.gsdbToTableEmit.emit(id);

    if (this.contactNAmeArr.length === 1) {
      let selected = this.contactNAmeArr[0];
      this.agreementForm.patchValue({
        contractName: selected?.ContactID,
        email: selected?.Email,
        phone: selected?.PhoneNumber,
      });
    } else {
      this.agreementForm.patchValue({
        contractName: '',
        email: '',
        phone: '',
      });
    }
  }

  onFileSelected(event: Event) {
    this.appService.onRAvalueChanged = true;
    const selectedFiles: FileList | null = (event.target as HTMLInputElement)
      .files;
    const allowedFormats = [
      'pdf',
      'docx',
      'doc',
      'xlsx',
      'xls',
      'ppt',
      'pptx',
      'csv',
      'txt',
      'png',
      'jpeg',
      'jpg',
    ];
    const maxSize = 500 * 1024; // 500KB

    if (selectedFiles) {
      const filesToAdd: File[] = [];

      for (let i = 0; i < selectedFiles.length; i++) {
        const file: any = selectedFiles[i];
        const fileType = file.name.split('.').pop().toLowerCase(); // Get the file format

        // Check if the file format is allowed
        if (!allowedFormats.includes(fileType)) {
          this.httpService.openSnackBar(
            `Invalid file format. Allowed formats: ${allowedFormats.join(', ')}`
          );
          continue; // Skip this file and move to the next one
        }

        // Check if the file size is within the limit
        if (file.size > maxSize) {
          this.httpService.openSnackBar('File size exceeds the limit of 500KB');
          continue; // Skip this file and move to the next one
        }

        // Add the file to the filesToAdd array
        filesToAdd.push(file);
      }

      this.files = [...this.files, ...filesToAdd];
      if (this.files.length >= 10) {
        this.httpService.openSnackBar('Upto 10 files only allowed to upload');
      }
      this.files = this.files.slice(0, 10);
    }
  }

  // onFileSelected(event: Event) {
  //   const selectedFiles:any = (event.target as HTMLInputElement).files;
  //   const allowedFormats = ['pdf', 'docx', 'doc', 'xlsx', 'xls', 'ppt', 'pptx', 'csv', 'txt', 'png', 'jpeg', 'jpg'];
  //   const maxSize = 500 * 1024; // 500KB

  //   if (selectedFiles) {
  //     // this.files = [...this.files, ...Array.from(selectedFiles)];
  //     for (let i = 0; i < 10; i++) {
  //       const file = selectedFiles[i];
  //       const fileType = file.name.split('.').pop().toLowerCase(); // Get the file format

  //       // Check if the file format is allowed
  //       if (!allowedFormats.includes(fileType)) {
  //         this.httpService.openSnackBar(`Invalid file format. Allowed formats:   ${allowedFormats.join(', ')}`)

  //         continue; // Skip this file and move to the next one
  //       }

  //       // Check if the file size is within the limit
  //       if (file.size > maxSize) {
  //         this.httpService.openSnackBar("File size exceeds the limit of 500KB")
  //         continue; // Skip this file and move to the next one
  //       }

  //     // Add the file to the files array
  //     this.files.push(file);
  //   }
  //   }
  //   // this.uploadFile(this.files);
  // }

  uploadFile(files: FileList, id: number) {
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], files[i].name);
      // Store the file locally
      // this.storeFileLocally(files[i]);
    }
    this.appService.isLoading = true;
    this.httpService
      .postFileToBlob('attachment', id, formData)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          this.httpService.openSnackBar('File uploaded successfully');
          this.fileToUpload(id);
        }
      });
  }

  fileToUpload(id: any) {
    // ['version','attachment'].forEach((i:string)=>{
    //   this.httpService.getFileUpload(i,id)
    //   .subscribe((res:any)=>{
    //     console.log("res...",res);
    //   })
    // })
    // ['version','attachment'].forEach((i:string)=>{
    // this.httpService.getFileUpload('attachment',id)
    // .subscribe((res:any)=>{
    //   console.log("res...",res);
    // })
    // })
  }

  // this.operation === "add"?null:Number( this.dataSource.RateAgreementID)
  storeFileLocally(file: File): void {
    const reader = new FileReader();
    const localStorageItems = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key: any = localStorage.key(i);
      const item = localStorage.getItem(key);
      localStorageItems.push({ key, item });
    }
    localStorage.clear();
    reader.onload = (event) => {
      const fileData = event.target?.result;
      if (fileData) {
        localStorage.setItem(file.name, fileData.toString());
      }
    };
    reader.readAsDataURL(file);
  }

  onSave() {
    // if(this.agreementForm.invalid){
    //   this.httpService.openSnackBar('Please fill all the required fields');
    //   return;
    // }

    if (!this.agreementForm.get('rateNumber')?.value) {
      this.httpService.openSnackBar('Please fill the Rate Agreement Number');
      return;
    }
    if ((this.agreementForm.get('rateNumber')?.value).length !== 6) {
      this.httpService.openSnackBar(
        'Rate Agreement Number should contain 6 characters...!'
      );
      return;
    } else if (this.agreementForm.get('rateNumber')?.value.includes(' ')) {
      this.httpService.openSnackBar(
        'Rate Agreement Number should not contain Empty Spaces.!'
      );
      return;
    } else if (
      !/^ra\d{4}$/.test(
        this.agreementForm.get('rateNumber')?.value.toLowerCase()
      )
    ) {
      this.httpService.openSnackBar(
        "Rate Agreement Number should start with 'RA' followed by four numbers"
      );
      return;
    }

    if (this.operation === 'view') {
      return;
    }

    let id =
      this.dataSource?.RateAgreementID === 0 ||
      this.dataSource?.RateAgreementID === null
        ? null
        : Number(this.dataSource?.RateAgreementID);
    // let carrierId = this.gsdbListArr.filter((item:any) => (""+item.CarrierID) ===""+(this.agreementForm.get('gsdb')?.value))

    let body = {
      RateAgreementID:
        this.operation === 'add'
          ? null
          : this.operation === 'edit' && this.copyActivity
          ? null
          : id,
      RateAgreementStatusID:
        this.operation === 'add'
          ? 39
          : Number(this.dataSource.RateAgreementStatusID),
      CarrierID: this.agreementForm.get('gsdb')?.value
        ? Number(this.agreementForm.get('gsdb')?.value)
        : null,
      CarrierContactID: this.agreementForm.get('contractName')?.value
        ? Number(this.agreementForm.get('contractName')?.value)
        : null,
      RateAgreementNumber: this.agreementForm.get('rateNumber')?.value
        ? this.agreementForm.get('rateNumber')?.value
        : null,
      RevisionNumber: Number(this.agreementForm.get('revisionNum')?.value),
      EffectiveDate: this.appService.dateFormate(
        this.agreementForm.get('effectiveDate')?.value
      ),
      ExpiryDate: this.appService.dateFormate(
        this.agreementForm.get('expiryDate')?.value
      ),
      DescriptionofService: this.appService.escapeSingleQuotes(
        this.agreementForm.get('description')?.value
      ),
      AutoExtensionFlag:
        this.agreementForm.get('autoExtent')?.value === ''
          ? null
          : this.agreementForm.get('autoExtent')?.value === 'Yes'
          ? true
          : false,
      NoticePeriod: this.agreementForm.get('noticePeriod')?.value
        ? Number(this.agreementForm.get('noticePeriod')?.value)
        : null,
      RenewalTerm: this.agreementForm.get('renewal')?.value
        ? Number(this.agreementForm.get('renewal')?.value)
        : null,
      ContractDuration: this.agreementForm.get('duration')?.value,
      InitialContractEffectiveDate: this.agreementForm.get('initalDate')?.value
        ? this.appService.dateFormate(
            this.agreementForm.get('initalDate')?.value
          )
        : null,
      SupersedesRANo: this.agreementForm.get('supersedes')?.value,
      ReasonforRevision: this.appService.escapeSingleQuotes(
        this.agreementForm.get('revision')?.value
      ),
      PaymentTerms: Number(this.agreementForm.get('payment')?.value),
      CurrencyID: Number(this.agreementForm.get('currency')?.value),
      VATCode: this.agreementForm.get('taxCode')?.value,
      CommodityID: this.agreementForm.get('commodity')?.value
        ? this.agreementForm.get('commodity')?.value
        : null,
      VolumeGuarantees: this.appService.escapeSingleQuotes(
        this.agreementForm.get('guarantees')?.value
      ),
      MarketTest: this.appService.escapeSingleQuotes(
        this.agreementForm.get('marketTest')?.value
      ),
      Specification: this.appService.escapeSingleQuotes(
        this.agreementForm.get('specification')?.value
      ),
      AutoExtensionComment: this.appService.escapeSingleQuotes(
        this.agreementForm.get('autoComment')?.value
      ),
      BuyerContactID: this.agreementForm.get('buyermail')?.value
        ? Number(this.agreementForm.get('buyermail')?.value)
        : null,
      SpecialTerms: [...new Set(this.files.map((item: any) => item.name))].join(
        ', '
      ),
      // 'OldExpiryDate':this.agreementForm.get('oldExpiryDate')?.value,
      RecordRetentionPeriod: Number(
        this.agreementForm.get('retentionPeriod')?.value
      ),
      RecordRetentionDate: this.agreementForm.get('retentionDays')?.value
        ? this.onChangeDateFormat(
            this.agreementForm.get('retentionDays')?.value
          )
        : null,
      GISNumberID: Number(this.gisNumberList[0].LookUpID),
      GISClassificationID: Number(this.gisClassList[0].LookUpID),
      UserEmail: this.userData.Email,
    };

    if (this.operation === 'edit' && this.copyActivity) {
      // this.copyActivity = false;
      this.appService.copyActivity = true;
    }

    const commonElements = this.dbFiles.filter((element: any) =>
      this.removedFiles.includes(element)
    );

    if (commonElements.length > 0 && this.operation !== 'add') {
      for (let i = 0; i < commonElements.length; i++) {
        // if(this.dbFiles.includes(this.removedFiles[i])){

        // return;
        this.httpService
          .getAttachFileDeleted(
            this.dataSource.RateAgreementID,
            commonElements[i]
          )
          .subscribe((res: any) => {
            // this.files.splice(this.removedFiles[i].id,1);
          });
        // }
      }
    }

    this.appService.isLoading = true;
    this.appService.raIsLoading = true;
    this.httpService.setAgreementDetails(body).subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res.length > 0) {
        this.appService.raSAve = true;
        if (res[0]?.DuplicateFlag === 1) {
          this.appService.raIsLoading = false;
          this.httpService.openSnackBar(
            'Rate Agreement Number, Revision Number and Status already exists'
          );
        } else if (res[0]?.DuplicateFlag === 2) {
          this.appService.raIsLoading = false;
          this.httpService.openSnackBar(
            'Rate Agreement Number and Revision Number already exists'
          );
        } else {
          this.appService.rateAgreementSaveemit.emit({
            copy: this.copyActivity,
            id: res[0]?.RateAgreementTableID
              ? res[0]?.RateAgreementTableID
              : null,
          });
          if (!this.files || this.files.length === 0) {
            return;
          }
          if (res[0]?.RateAgreementTableID) {
            this.uploadFile(this.files, res[0]?.RateAgreementTableID);
          } else {
            this.uploadFile(this.files, this.dataSource?.RateAgreementTableID);
          }
        }

        //  return;
      }
    });
  }

  onChangeDateFormat(val: string) {
    return val?.split('/').reverse().join('-');
  }

  toUpdateOnField() {
    this.minEffectiveDate = new Date();
    this.agreementForm.enable();
    this.selectedContact = false;
    if (this.operation === 'add') {
      this.appService.rateOutputData = [];
      this.appService.rateDateSource = [];
      this.appService.rateTableList = [];
      this.minDate = this.appService.getDateWithSTDFormatNewValue(1, 0, 0);
      this.agreementForm.patchValue({
        createdBy: this.userData.Email.includes('dhl')
          ? 'LLP User'
          : this.userData.Email,
        effectiveDate: this.appService.getDateWithSTDFormatNewValue(1, 0, 0),
        expiryDate: this.appService.getDateWithSTDFormatNewValue(0, 0, 3),
        retentionDays: this.appService.getDateWithNewValue(0, 0, 15),
        // createdDate: this.appService.getToday(),
        modifiedDate: '', //this.appService.getWithFormatToday(),
        createdDate: this.appService.getWithFormatToday(),
        // gisclassfication:this.gisClassList[0]?.LookUpID,
        // gisNumber: this.gisNumberList[0]?.LookUpID,
        modifiedBy: '', //(this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
        gsdb: '',
        contractName: '',
        buyermail: '',
        autoExtent: '',
        currency: '',
        commodity: '',
      });
      return;
    }
    if (this.operation === 'view') {
      this.agreementForm.disable();
      this.agreementForm.disable();
    }
    this.minDate = new Date(this.dataSource.EffectiveDate);
    this.minEffectiveDate = new Date();

    setTimeout(() => {
      this.appService.gsdbToTableEmit.emit(this.dataSource.CarrierID);
    }, 1000);

    this.agreementForm.patchValue({
      rateNumber: this.dataSource.RateAgreementNumber,
      effectiveDate: new Date(this.dataSource.EffectiveDate),
      revisionNum: this.dataSource.RevisionNumber,
      supersedes: this.dataSource.SupersedesRANo,
      expiryDate: new Date(this.dataSource.ExpiryDate),
      initalDate: new Date(this.dataSource.InitialContractEffectiveDate),

      gsdb: this.dataSource.CarrierID === null ? '' : this.dataSource.CarrierID,
      carrierName: this.dataSource.Name,
      contractName:
        this.dataSource.CarrierContactID === null
          ? ''
          : this.dataSource.CarrierContactID,
      marketTest: this.appService.deResingDoubleQuotess(
        this.dataSource.MarketTest
      ),

      street: this.dataSource.Street,
      city: this.dataSource.City,
      country: this.dataSource.Country,
      taxCode: this.dataSource.VATCode,
      zipCode: this.dataSource.Postcode,
      email: this.dataSource.Email,
      phone: this.dataSource.Telephone,
      description: this.appService.deResingDoubleQuotess(
        this.dataSource.DescriptionofService
      ),

      buyerName: this.dataSource['Buyer Name'],
      buyerCode: this.dataSource.BuyerCode,
      buyermail:
        this.dataSource.BuyerContactID === null
          ? ''
          : this.dataSource.BuyerContactID,
      buyerLocation: this.dataSource.BuyerLocation,
      buyerPhone: this.dataSource.BuyerTelephone,

      revision: this.appService.deResingDoubleQuotess(
        this.dataSource.ReasonforRevision
      ),
      specification: this.appService.deResingDoubleQuotess(
        this.dataSource.Specification
      ),
      guarantees: this.appService.deResingDoubleQuotess(
        this.dataSource.VolumeGuarantees
      ),

      autoExtent:
        this.dataSource.AutoExtensionFlag === null
          ? ''
          : this.dataSource.AutoExtensionFlag,
      autoComment: this.appService.deResingDoubleQuotess(
        this.dataSource.AutoExtensionComment
      ),
      noticePeriod: this.dataSource.NoticePeriod,
      renewal: this.dataSource.RenewalTerm,

      duration: this.dataSource.ContractDuration,
      payment: this.dataSource.PaymentTerms,
      commodity:
        this.dataSource.CommodityID === null ? '' : this.dataSource.CommodityID,
      currency: this.dataSource.CurrencyID,

      oldExpiryDate: this.dataSource.OldExpiryDate
        ? this.appService.excelDateFormate(this.dataSource.OldExpiryDate)
        : '',
      // oldExpiryDate:this.appService.dateFormate(this.dataSource.OldExpiryDate),
      gisclassfication: this.dataSource.GISClassification,
      retentionPeriod: this.dataSource.RecordRetentionPeriod,
      retentionDays: this.appService.excelDateFormate(
        this.dataSource.RecordRetentionDate
      ),
      // retentionDays: this.appService.dateFormate(this.dataSource.RecordRetentionDate),
      gisNumber: this.dataSource.GISNumber,

      // createdDate: this.appService.dateFormate(this.dataSource.CreatedOn),
      // modifiedDate: this.appService.dateFormate(this.dataSource.ModifiedOn),
      createdDate: this.tableService.checkOnInvalidDate(
        this.dataSource.CreatedOn
      ),
      modifiedDate: this.dataSource.ModifiedOn
        ? this.tableService.checkOnInvalidDate(this.dataSource.ModifiedOn)
        : '',
      createdBy: this.dataSource.CreatedBy,
      modifiedBy: this.dataSource.ModifiedBy,
    });
    this.autoFlag = this.dataSource.AutoExtensionFlag
      ? this.dataSource.AutoExtensionFlag === 'No'
        ? false
        : true
      : false;
    this.checkOnAutoFlag(true);
  }

  onDaetChange(e: any, name: string) {
    if (e) {
      if (name === 'effectiveDate') {
        this.minDate = e;
      } else if (name === 'expiryDate') {
        this.agreementForm.get('expiryDate')?.setValue(e);
        this.agreementForm
          .get('retentionDays')
          ?.setValue(
            this.appService.getDateWithNewValue(
              this.calculateDateDiffrence(),
              0,
              Number(this.agreementForm.get('retentionPeriod')?.value)
            )
          );
      }
      this.agreementForm.get(name)?.setValue(e);
    }
  }

  checkOnAutoFlag(boo = false) {
    if (this.autoFlag) {
      this.setAndRemoveValidator('noticePeriod', true);
      this.setAndRemoveValidator('renewal', true);
      this.agreementForm
        .get('noticePeriod')
        ?.setValue(boo ? this.dataSource.NoticePeriod : 3);
      this.agreementForm
        .get('renewal')
        ?.setValue(boo ? this.dataSource.RenewalTerm : 12);
    } else {
      this.setAndRemoveValidator('noticePeriod', false);
      this.setAndRemoveValidator('renewal', false);
      this.agreementForm.get('noticePeriod')?.setValue(null);
      this.agreementForm.get('renewal')?.setValue(null);
    }
  }

  setAndRemoveValidator(name: string, required: boolean) {
    this.agreementForm
      .get(name)
      ?.setValidators(required ? Validators.required : null);
    this.agreementForm.get(name)?.updateValueAndValidity();
  }

  onSelectClick(menu: string) {
    this.appService.isLoading = true;
    if (menu === 'contactName') {
      this.contactNAmeArr = this.contactListArr.filter(
        (item: any) =>
          item.Status !== 'Terminated' &&
          item.CarrierID === +this.agreementForm.get('gsdb')?.value
      ); //(+item.ContactTypeID === 19) &&
      this.contactNAmeArr.sort((a: any, b: any) =>
        a.LastName.toLowerCase() > b.LastName.toLowerCase() ? 1 : -1
      );
      this.contactNAmeArr = this.contactNAmeArr.filter(
        (item: any) => item.IsActive === true
      );
    } else if (menu === 'gsdb') {
      // this.agreementForm.patchValue({
      //   contractName:null,
      //   email: '',
      //   phone:'',
      // });
      this.gsdbListArr = this.gsdbListArr.filter(
        (item: any) => item.IsActive === true && item.Status !== 'Terminated'
      );
      if (this.gsdbListArr.length === 1) {
        let selected = this.gsdbListArr[0];
        this.getContact(selected?.CarrierID);
        // this.agreementForm.patchValue({
        //   contractName:selected.ContactID,
        //   email: selected?.Email,
        //   phone:selected?.PhoneNumber,
        // });
      }
    } else if (menu === 'buyerEmail') {
      this.buyerMail = this.buyerMail.filter(
        (item: any) => item.IsActive === true && item.Status !== 'Terminated'
      );
      if (this.buyerMail.length === 1) {
        let selected = this.buyerMail[0];
        this.agreementForm.patchValue({
          buyerName: selected?.FirstName + ' ' + selected?.LastName,
          buyerCode: selected?.BuyerCode,
          buyerLocation: selected?.BuyerLocation,
          buyerPhone: selected?.PhoneNumber,
          buyerEmail: selected?.ContactID,
        });
      }
    }
    this.appService.isLoading = false;
  }

  onOptionChange(e: any, menu: string) {
    if (menu === 'contactName') {
      let selected = this.contactNAmeArr.find(
        (item: any) => item.ContactID === Number(e.value)
      );
      this.agreementForm.patchValue({
        email: selected?.Email,
        phone: selected?.PhoneNumber,
      });
    } else if (menu === 'gsdb') {
      let selected = this.gsdbListArr.find(
        (item: any) => '' + item.CarrierID === e.value
      );
      // this.agreementForm.patchValue({
      //   contractName:null,
      //   email: '',
      //   phone:'',
      // });
      this.selectedContact = true;
      this.agreementForm.patchValue({
        carrierName: selected?.Name,
        street: selected?.Street,
        city: selected?.City,
        country: selected?.CountryName,
        taxCode: selected?.VATCode,
        zipCode: selected?.Postcode,
      });
      this.getContact(selected.CarrierID);
    } else if (menu === 'buyerEmail') {
      let selected = this.buyerMail.find(
        (item: any) => item.ContactID === Number(e.value)
      );
      this.agreementForm.patchValue({
        buyerName: selected?.FirstName + ' ' + selected?.LastName,
        buyerCode: selected?.BuyerCode,
        buyerLocation: selected?.BuyerLocation,
        buyerPhone: selected?.PhoneNumber,
      });
    } else if (menu === 'autoExtent') {
      this.autoFlag = e.value === 'Yes' ? true : false;
      this.checkOnAutoFlag();
    } else if (menu === 'retentionPeriod') {
      this.agreementForm
        .get('retentionDays')
        ?.setValue(
          this.appService.getDateWithNewValue(
            this.calculateDateDiffrence(),
            0,
            Number(e.value)
          ),
          false
        );
    }
  }

  calculateDateDiffrence() {
    const date1 = new Date();
    const date2 = this.agreementForm.get('expiryDate')?.value;

    const d1: any = new Date(
      date1.getFullYear(),
      date1.getMonth(),
      date1.getDate()
    );
    const d2: any = new Date(
      date2.getFullYear(),
      date2.getMonth(),
      date2.getDate()
    );
    const differenceInDays = Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24));
    return differenceInDays;
  }

  isDateGreaterThanCurrentDate(givenDate: Date): boolean {
    const currentDate = new Date(); // Get the current date

    // Compare the given date with the current date
    if (givenDate > currentDate) {
      return true; // Given date is greater than the current date
    } else {
      return false; // Given date is not greater than the current date
    }
  }

  onDragOver(e: any) {}
  onDragLeave(e: any) {}
  onDrop(e: any) {}
}
